import { render } from "./404.vue?vue&type=template&id=861fb678&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=861fb678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861fb678"]])

export default __exports__